const navGroups = [
  {
    title: "内容板块",
    links: [
      { label: "题材概览", href: "#overview" },
      { label: "场景对比", href: "#compare" },
      { label: "角色原型", href: "#roles" },
      { label: "情境筛选", href: "#scenarios" },
    ],
  },
  {
    title: "深入阅读",
    links: [
      { label: "互动解析", href: "#details" },
      { label: "章节脉络", href: "#chapters" },
      { label: "观看路径", href: "#path" },
      { label: "常见问题", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100 pt-14 md:pt-16 pb-8">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md flex items-center justify-center bg-primary-500 text-foreground-950">
                <i className="ri-book-marked-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                秘密教学
              </span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-100/70 max-w-md">
              围绕秘密教学中的师生家教题材，深入解析家教、私教、补习、辅导等场景下的角色关系与互动细节，
              适合关注师生题材的观众快速了解内容全貌，并找到对应观看入口。
            </p>
          </div>

          {navGroups.map((group) => (
            <div key={group.title} className="md:col-span-3">
              <h4 className="font-heading text-base font-bold text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="inline-flex items-center gap-1.5 text-sm text-background-100/70 hover:text-primary-300 transition-colors"
                    >
                      <i className="ri-arrow-right-s-line" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <a
              href="#top"
              aria-label="返回页面顶部"
              className="w-11 h-11 rounded-md flex items-center justify-center border border-background-100/25 text-background-100 hover:bg-background-100/10 transition-colors"
            >
              <i className="ri-arrow-up-line text-lg" />
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-label text-xs text-background-100/55">
            © 2026 秘密教学 · 师生家教题材内容整理
          </p>
          <p className="font-label text-xs text-background-100/55">
            本站为题材信息科普与整理页面，内容均为一般性说明，不涉及任何真实个人资料。
          </p>
        </div>
      </div>
    </footer>
  );
}